import React from "react";

export const SpaceWrapperHeader = ({ children }) => (
  <div className="w-full bg-blue-500 text-white p-4 rounded-lg shadow-md">
    {children}
  </div>
);

export const SpaceWrapperFooter = ({ children }) => (
  <div className="w-full bg-gray-800 text-white p-4 mt-6 rounded-lg text-center">
    {children}
  </div>
);

const SpaceWrapper = ({ children, className = "" }) => {
  // Extract specific children based on their type
  const header = React.Children.toArray(children).find(
    (child) => child.type === SpaceWrapperHeader
  );

  const footer = React.Children.toArray(children).find(
    (child) => child.type === SpaceWrapperFooter
  );

  // Render the Wrapper
  return (
    <div className="w-full flex flex-col items-center justify-center h-full ">
      {/* Render Header if Provided */}
      {header && header}

      {/* Render the rest of the content */}
      <div className={`w-full h-full overflow-y-auto pb-4 ${className}`}>
        {React.Children.toArray(children).filter(
          (child) =>
            child.type !== SpaceWrapperHeader &&
            child.type !== SpaceWrapperFooter
        )}
      </div>

      {/* Render Footer if Provided */}
      {footer && footer}
    </div>
  );
};

export default SpaceWrapper;
